var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "#a3a3a3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 4 9 L 4 18 71 18 L 138 18 138 9 L 138 0 71 0 L 4 0 4 9 M 43.742 60.758 L 16.997 87.517 23.238 93.758 L 29.479 99.999 45.739 83.761 L 62 67.523 62 104.761 L 62 142 70.500 142 L 79 142 79 104.761 L 79 67.523 95.270 83.770 L 111.540 100.018 117.760 93.742 L 123.980 87.466 97.233 60.733 L 70.486 34 43.742 60.758",
    stroke: "none",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsert);
export default __webpack_public_path__ + "static/media/insert.cae92b0eb7c7644b17d64e7e4d83eb79.svg";
export { ForwardRef as ReactComponent };